export const FrameResource = {
  "ExpressionTitle": "高级表达式",
  "ExpressionSave": "保存",
  "ExpressionCancel": "取消",
  "CheckFront": "校验",
  "ResetFront": "重置",
  "AiAssistant": "智能助手",
  "HelpFront": "说明",
  "ImportFront": "导入",
  "Advanced": "高级",
  "String": "字符",
  "Estimate": "判断",
  "DateTime": "时间",
  "Translate": "转换",
  "Analytical": "数据",
  "Math": "数学",
  "Extend": "扩展",
  "FunctionSemanticName": "语义化名称",
  "FunctionName": "函数名称",
  "FunctionParameter": "参数",
  "Variable": "变量",
  "VariableSessionValue": "会话",
  "VariableContextParameter": "上下文",
  "VariableName": "名称",
  "VariableSemanticNameValue": "语义化名称",
  "Entity": "数据模型",
  "EntityAllColumn": "编号/名称",
  "EntityCode": "编号",
  "EntityName": "名称",
  "EntityType": "类型",
  "EntityPropList": "属性列表",
  "Help": "帮助",
  "HelpCode": "编号",
  "HelpName": "名称",
  "HelpDesc": "请选择",
  "HelpDescription": "请选择",
  "SaveButton": "保存",
  "CancelButton": "取消",
  "FunctionDescription": "函数说明：",
  "VarDescription": "变量说明：",
  "CurrentProp": "当前属性：",
  "CurrentChosedProp": "当前选择属性：",
  "PopverTitleDesc": "使用说明",
  "HelpButtonDesc": {
    $implicit: {
      'syntax': '语法支持',
      'desc': '支持JavaScript语法,不支持"and、or、in、not in"等写法,可用&&代替and，||代替or',
      'buttonDesc': '按钮',
      'checkButtonDesc': '校验：语法校验',
      'resetButtonDesc': '重置：清空编辑框',
      'functionDesc': '函数',
      'clickFunctionDesc': '单击：展示函数说明，参数，返回类型和示例',
      'dbclickFunctionDesc': '双击：将函数插入到编辑框中',
      'entityDesc': '数据',
      'insertByStructureDesc': '按结构：将形如"saleOrder.code"的链式结构插值到编辑框中',
      'insertByPropertyDesc': '按属性：将"code"属性插值到编辑框中',
      'otherDesc': '其他',
      'areaChangeDesc': '区域伸缩：函数区域和数据区域可以改变大小',
      'chainedStrucDesc': '链式结构：形如"saleOrder.code"以.分隔的结构为链式结构'
    }
  },
  "InsertType": "插值方式",
  "InsertByStruct": "结构",
  "InsertByAttr": "属性",
  "GetEnum": "枚举取值",
  "EnumJudge": "枚举判断",
  "NewDataTypeString": "字符串",
  "NewDataTypeByte": "字节",
  "NewDataTypeBoolean": "布尔",
  "NewDataTypeDate": "日期",
  "NewDataTypeDateTime": "日期时间",
  "NewDataTypeDecimal": "十进制数",
  "NewDataTypeInteger": "整数",
  "NewDataTypeEnum": "枚举",
  "EntityType_Main": "主表",
  "EntityType_ChildTable": "子表",
  "EntityType_Other": "实体",
  "EntitySet": "子表",
  "EntityEnum": "枚举",
  "EntityEnum_Int": "整数",
  "EntityEnum_String": "字符串"
}